<template>
  <div>
    <dental-review v-if="isDentalSimulation" />
    <default-review v-else />
  </div>
</template>

<script>
import DentalReview from '@/components/sims/sectionReview/DentalReview.vue';
import DefaultReview from '@/components/sims/sectionReview/DefaultReview.vue';
import WuxSimulationsMixin from '@/mixins/wux-simulations';

export default {
  components: {
    DentalReview,
    DefaultReview,
  },
  mixins: [WuxSimulationsMixin],
};
</script>
